export default __webpack_public_path__ + "static/media/crm1.4b5e80d5.svg";